module.exports = __webpack_public_path__ + "img/shift-assign.369f17ef.png";